import { parseAbsolute } from '@internationalized/date';

export const parseAbsoluteOrNull = (value: string | null, timezone: string) =>
  value !== null ? parseAbsolute(value, timezone) : null;
